export default class {

  /**
   *
   * @param translator
   */
  constructor (translator) {
    this.translator = translator
  }

  /**
   *
   * @return {*[]}
   */
  getMonths () {
    return [
      this._tr('date_months_January'),
      this._tr('date_months_February'),
      this._tr('date_months_March'),
      this._tr('date_months_April'),
      this._tr('date_months_May'),
      this._tr('date_months_June'),
      this._tr('date_months_July'),
      this._tr('date_months_August'),
      this._tr('date_months_October'),
      this._tr('date_months_November'),
      this._tr('date_months_December')
    ]
  }

  /**
   *
   * @return {*[]}
   */
  getShortMonths () {
    return [
      this._tr('date_monthsShort_Jan'),
      this._tr('date_monthsShort_Feb'),
      this._tr('date_monthsShort_Mar'),
      this._tr('date_monthsShort_Apr'),
      this._tr('date_monthsShort_May'),
      this._tr('date_monthsShort_Jun'),
      this._tr('date_monthsShort_Jul'),
      this._tr('date_monthsShort_Aug'),
      this._tr('date_monthsShort_Sep'),
      this._tr('date_monthsShort_Oct'),
      this._tr('date_monthsShort_Nov'),
      this._tr('date_monthsShort_Dec')
    ]
  }

  /**
   *
   * @return {*[]}
   */
  getDays () {
    return [
      this._tr('date_days_Sunday'),
      this._tr('date_days_Monday'),
      this._tr('date_days_Tuesday'),
      this._tr('date_days_Wednesday'),
      this._tr('date_days_Thursday'),
      this._tr('date_days_Friday'),
      this._tr('date_days_Saturday')
    ]
  }

  getShortDays () {
    return [
      this._tr('date_daysShort_Sun'),
      this._tr('date_daysShort_Mon'),
      this._tr('date_daysShort_Tue'),
      this._tr('date_daysShort_Wed'),
      this._tr('date_daysShort_Thu'),
      this._tr('date_daysShort_Fri'),
      this._tr('date_daysShort_Sat')
    ]
  }

  getMinDays () {
    return [
      this._tr('date_daysMin_Su'),
      this._tr('date_daysMin_Mo'),
      this._tr('date_daysMin_Tu'),
      this._tr('date_daysMin_We'),
      this._tr('date_daysMin_Th'),
      this._tr('date_daysMin_Fr'),
      this._tr('date_daysMin_Sa')
    ]
  }

  /**
   *
   * @param key
   * @return {*}
   * @private
   */
  _tr (key) {
    let text = this.translator.text(key)
    return text ? text : ''
  }
}